export default function WarningIcon() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0219 5.75391C20.2356 1.92057 25.771 1.92057 27.9828 5.75391L42.0799 30.1876C44.2917 34.0209 41.5241 38.8126 37.0985 38.8126H8.90623C4.48065 38.8126 1.7149 34.0209 3.92673 30.1876L18.02 5.75391H18.0219ZM23.0033 15.8107C23.3846 15.8107 23.7502 15.9621 24.0198 16.2317C24.2894 16.5013 24.4408 16.8669 24.4408 17.2482V24.4357C24.4408 24.8169 24.2894 25.1825 24.0198 25.4521C23.7502 25.7217 23.3846 25.8732 23.0033 25.8732C22.6221 25.8732 22.2564 25.7217 21.9868 25.4521C21.7173 25.1825 21.5658 24.8169 21.5658 24.4357V17.2482C21.5658 16.8669 21.7173 16.5013 21.9868 16.2317C22.2564 15.9621 22.6221 15.8107 23.0033 15.8107ZM23.0033 31.6232C23.3846 31.6232 23.7502 31.4717 24.0198 31.2021C24.2894 30.9325 24.4408 30.5669 24.4408 30.1857C24.4408 29.8044 24.2894 29.4388 24.0198 29.1692C23.7502 28.8996 23.3846 28.7482 23.0033 28.7482C22.6221 28.7482 22.2564 28.8996 21.9868 29.1692C21.7173 29.4388 21.5658 29.8044 21.5658 30.1857C21.5658 30.5669 21.7173 30.9325 21.9868 31.2021C22.2564 31.4717 22.6221 31.6232 23.0033 31.6232Z"
        fill="#FEA735"
      />
    </svg>
  );
}
